<template>
  <div class="virtual-category-tree">
    <div
      class="virtual-category-tree__element"
      :class="{ 'virtual-category-tree__element--selected': isSelected }"
      @click="$emit('input', item.value)"
    >
      <div>
        <div class="virtual-category-tree__level" v-for="n in level - 1" :key="n"></div>
      </div>
      <button v-if="item.items.length || mode() === 'default'" type="button" @click.stop="toggle">
        <FontAwesomeIcon :icon="['fal', isCollapsed ? 'plus-circle' : 'minus-circle']" />
      </button>
      <span>{{ item.label }}</span>
    </div>

    <div v-show="!isCollapsed" class="virtual-category-tree__children">
      <Tree
        v-for="(item, index) in item.items"
        :value="value"
        :item="item"
        :key="index"
        :level="level + 1"
        v-on="{
          ...$listeners,
          expand: expand,
        }"
        class="virtual-category-tree__child"
      />
      <Create
        :placeholder="$t('addCategory') + '...'"
        :level="level + 1"
        :scope="item.value"
        @create="$ev => $emit('create', $ev)"
      />
    </div>
  </div>
</template>

<script>
import Create from './Create'
export default {
  name: 'Tree',
  props: {
    value: String,
    item: Object,
    level: {
      type: Number,
      default: 1,
    },
  },
  inject: ['mode', 'filter'],
  watch: {
    isSelected: {
      handler(val) {
        if (!val) return

        this.expand()
      },
      immediate: true,
    },
  },
  data() {
    return {
      isCollapsed: true,
      newItem: null,
    }
  },
  computed: {
    isSelected() {
      return this.value === this.item.value
    },
    isFiltered() {
      return new RegExp(this.filter().search, 'ig').test(this.item.value)
    },
  },
  methods: {
    toggle() {
      if (this.isCollapsed) this.expand()
      else this.isCollapsed = true
    },
    expand() {
      this.isCollapsed = false
      this.$emit('expand')
    },
  },
  components: {
    Create,
  },
}
</script>

<style lang="scss">
.virtual-category-tree {
  &__level {
    display: inline-block;
    opacity: 0.2;
    padding-right: 1rem;

    &:before {
      content: '∟';
      opacity: 0;
      transform: translateX(5px) translateY(-3px);
      display: inline-block;
    }

    &:last-child:before {
      opacity: 1;
    }
  }

  &__element {
    cursor: pointer;
    padding: 1rem;
    transition: background-color 150ms ease, border-color 150ms ease;
    border: 1px solid transparent;
    border-top-color: css-alpha('border-color', 0.5);
    display: flex;

    flex-wrap: wrap;
    align-items: center;

    &:hover {
      background-color: css-alpha('border-color', 0.3);
    }

    &--selected {
      background-color: css-alpha('primary', 0.1) !important;
      border-color: css-alpha('primary', 0.3) !important;
    }

    button {
      display: flex;
      cursor: inherit;
    }
  }

  svg {
    margin-right: 0.5rem;
    opacity: 0.75;
  }
}
</style>
